//Hero Slider Script
$("#Hero-slider").slick({
    dots: true
});

const input = document.querySelector(".search-product-form input");
const buttons = document.querySelectorAll(".search-product-form button");
input.addEventListener("keydown", function (e) {
  if (e.key === "Enter") {
    e.preventDefault();
    if (buttons.length > 0) {
      buttons[0].click();
    }
  }
});


